import { render } from "./Boosts.vue?vue&type=template&id=2f250677&scoped=true"
import script from "./Boosts.vue?vue&type=script&lang=js"
export * from "./Boosts.vue?vue&type=script&lang=js"

import "./Boosts.vue?vue&type=style&index=0&id=2f250677&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f250677"]])

export default __exports__